import React from "react"
import Select from "@mui/material/Select"
import { Box, Button, Typography } from "@mui/material"
import { useDispatch } from "react-redux"
import { setPnlReportingMonths } from "../../../redux/slices/pnlReportingSlice"
import { useAppSelector } from "../../../redux/hooks"
import { strMonths } from "../../../pages/PnlReporting/constants"
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank"
import CheckBoxIcon from "@mui/icons-material/CheckBox"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import { colors } from "../../../../styles/commonStyles"

type monthSelectProps = {
  disabled: boolean
}
const PnlSelectDropdown = ({ disabled }: monthSelectProps) => {
  const dispatch = useDispatch()
  const { months } = useAppSelector((state) => state.pnlReporting)

  const [selectedMonths, setSelectedMonths] = React.useState<number[]>([])
  const [open, setOpen] = React.useState(false)

  const handleClose = () => {
    setOpen(false)
    if (selectedMonths.length === 0) {
      // toast.error("Atleast one month must be selected")
      dispatch(setPnlReportingMonths([]))
      // setSelectedMonths([1])
    } else {
      dispatch(setPnlReportingMonths([...selectedMonths]))
    }
  }

  const handleMonthToggle = (e: any, child: any) => {
    const month = child.props.children
    if (month === "Apply") {
      return
    }
    if (month === "Select all") {
      if (e.target.value.length >= 12) {
        setSelectedMonths([])
      } else {
        const allMonths = strMonths.map((_, index) => index + 1)
        setSelectedMonths(allMonths)
      }
    } else {
      const currentIndex = strMonths.indexOf(month) + 1
      let newSelectedMonths = [...selectedMonths]

      if (!selectedMonths.includes(currentIndex)) {
        newSelectedMonths.push(currentIndex)
      } else {
        newSelectedMonths = newSelectedMonths.filter(
          (index) => index !== currentIndex,
        )
      }

      setSelectedMonths(newSelectedMonths)
    }
  }

  const renderSelectedMonths = () => {
    if (selectedMonths.length === 0) {
      return "Select month(s)"
    }
    if (selectedMonths.length === 12) {
      return "All Months"
    }

    return selectedMonths
      .map((monthIndex: any) => {
        return strMonths[monthIndex - 1]
      })
      .join(", ")
  }

  const isAllSelected = selectedMonths.length >= 12

  React.useEffect(() => {
    setSelectedMonths([...months])
  }, [months])
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        justifyContent: "space-between",
        width: "400px",
        ml: "12px",
      }}
    >
      <Box>
        <Typography fontSize={"10px"}>Months</Typography>
        <Select
          disabled={disabled}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={handleClose}
          multiple
          value={selectedMonths}
          onChange={handleMonthToggle}
          IconComponent={KeyboardArrowDownIcon}
          renderValue={renderSelectedMonths}
          displayEmpty
          inputProps={{ "aria-label": "Select Months" }}
          sx={{
            height: "40px",
            minWidth: "210px",
            maxWidth: "210px",
            mt: "5px",
            backgroundColor: "#fff",
            fontSize: "14px",
          }}
        >
          <Button
            disableFocusRipple
            key={"select-all"}
            variant="outlined"
            startIcon={
              isAllSelected ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />
            }
            sx={{
              height: "40px",
              width: "190px",
              textTransform: "none",
              color: isAllSelected ? colors.primaryBlue : "#000",
              fontWeight: "bold",
              mx: "10px",
              borderWidth: 0,
              justifyContent: "flex-start",
            }}
          >
            Select all
          </Button>
          {strMonths.map((month: string, index: number) => {
            const checked = selectedMonths.includes(index + 1)
            return (
              <Button
                disableFocusRipple
                key={month}
                variant="outlined"
                startIcon={
                  checked ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />
                }
                sx={{
                  height: "40px",
                  width: "190px",
                  color: checked ? colors.primaryBlue : "#000",
                  textTransform: "none",
                  fontWeight: "bold",
                  mx: "10px",
                  borderWidth: 0,
                  justifyContent: "flex-start",
                }}
              >
                {month}
              </Button>
            )
          })}
          <Button
            disableFocusRipple
            key={"apply-close"}
            variant="contained"
            onClick={handleClose}
            sx={{
              height: "40px",
              width: "190px",
              textTransform: "none",
              fontWeight: "bold",
              justifyContent: "center",
              mx: "10px",
              mt: "5px",
              borderWidth: 0,
              backgroundColor: colors.primaryBlue,
            }}
          >
            Apply
          </Button>
        </Select>
      </Box>
    </Box>
  )
}

export default PnlSelectDropdown
